import ComponentElement from 'components/component-element';

/**
 * Чекбокс
 */
function Checkbox($element, options = {}) {
    ComponentElement.call(this, $element, options);

    this.$item = this.$element.querySelector('.js-checkboxItem');
    this.$checkbox = this.$element.querySelector('.js-checkboxField');
    this.$checkbox.addEventListener('change', this._onChangeEvent.bind(this));

    Object.defineProperty(this, 'checked', {
        get: this.getChecked.bind(this),
        set: this.setChecked.bind(this),
    });
}

// цепочка прототипов
Checkbox.prototype = Object.create(ComponentElement.prototype)
Object.defineProperty(Checkbox.prototype, 'constructor', {
    value: Checkbox,
    enumerable: false,
    writable: true,
});

Checkbox.prototype.setChecked = function(state) {
    state = !!state;
    this.$checkbox.checked = state;
    this.$item.classList.toggle('is-active', state);
    this.emit('checked', state);
}

Checkbox.prototype.getChecked = function() {
    return this.$checkbox.checked;
}

Checkbox.prototype._onChangeEvent = function(e) {
    this.setChecked(this.$checkbox.checked);
}

export default Checkbox;
